import { useParams } from "react-router-dom";
import Seo from "../components/Seo";

const IMPRINT = {
  firm: "THE VAINOR VENTURES (प्रोपराइटरशिप फर्म)",
  proprietor: "Lokendra Singh",
  gstin: "08KVFPS4146R1ZH",
  udyam: "UDYAM-RJ-18-0024177",
  address: "Baiya, Fatehgarh, Jaisalmer, Rajasthan – 345027",
  email: "Thevainorventures@gmail.com",
  phone: "+91 95210 18646",
};

const PAGES = {
  about: {
    title: "हमारे बारे में",
    body: [
      "द वैनोर इंडिया (The Vainor India) राजस्थान के जैसलमेर से प्रकाशित होने वाला एक स्वतंत्र हिंदी-English डिजिटल समाचार पोर्टल है। हमारा लक्ष्य है — सत्य, निष्पक्षता और निर्भीकता के साथ हर ख़बर, सबसे पहले।",
      "हम राजस्थान के 41 ज़िलों, देश और विदेश की ख़बरें, राजनीति, बिज़नेस, खेल, मनोरंजन, टेक और लाइफस्टाइल तक का कवरेज देते हैं। हमारी हर ख़बर पाठकों के लिए मुफ़्त है।",
      `यह पोर्टल ${IMPRINT.firm} का प्रकाशन है। प्रोपराइटर: ${IMPRINT.proprietor}।`,
    ],
  },
  contact: {
    title: "संपर्क",
    body: [
      `समाचार टिप्स, सुझाव या विज्ञापन के लिए हमसे संपर्क करें:`,
      `ईमेल: ${IMPRINT.email}`,
      `फ़ोन: ${IMPRINT.phone}`,
      `पता: ${IMPRINT.address}`,
      "हम कार्यदिवसों में 24-48 घंटों के भीतर जवाब देने का प्रयास करते हैं।",
    ],
  },
  privacy: {
    title: "प्राइवेसी पॉलिसी",
    body: [
      "हम आपकी निजता का सम्मान करते हैं। यह नीति बताती है कि हम कौन-सी जानकारी लेते हैं और उसका उपयोग कैसे करते हैं।",
      "टिप्पणी करते समय आपका नाम और टिप्पणी सार्वजनिक रूप से दिखाई देती है। WhatsApp अलर्ट के लिए दिया गया नंबर केवल ब्रेकिंग न्यूज़ अलर्ट भेजने के लिए इस्तेमाल होता है और किसी तीसरे पक्ष को नहीं दिया जाता।",
      "सहयोग (दान) के दौरान भुगतान की जानकारी Razorpay द्वारा सुरक्षित रूप से संसाधित होती है; हम आपके कार्ड/UPI की जानकारी अपने सर्वर पर नहीं रखते।",
      "हम साइट सुधारने के लिए सामान्य उपयोग-आँकड़े (जैसे पेज व्यू) देखते हैं। कुकीज़ का उपयोग केवल भाषा-पसंद जैसी सेटिंग याद रखने के लिए होता है।",
      "अपना डेटा हटाने या किसी भी सवाल के लिए हमें ईमेल करें।",
    ],
  },
  terms: {
    title: "नियम व शर्तें",
    body: [
      "द वैनोर इंडिया का उपयोग करते हुए आप इन शर्तों से सहमत होते हैं।",
      "इस साइट पर प्रकाशित सामग्री केवल सामान्य सूचना के लिए है। एजेंसी/सिंडिकेटेड ख़बरों का मूल स्रोत संबंधित प्रकाशक होता है; उनकी सटीकता की ज़िम्मेदारी मूल स्रोत की होती है।",
      "टिप्पणियों में आपत्तिजनक, मानहानिकारक या गैरकानूनी सामग्री प्रतिबंधित है। उल्लंघन करने वाली टिप्पणियाँ बिना सूचना के हटाई जा सकती हैं।",
      "साइट की सामग्री का स्वामित्व The Vainor Ventures के पास है; बिना अनुमति के पुनर्प्रकाशन प्रतिबंधित है।",
    ],
  },
  corrections: {
    title: "सुधार नीति",
    body: [
      "हम सटीकता के प्रति प्रतिबद्ध हैं। यदि किसी ख़बर में कोई तथ्यात्मक ग़लती पाई जाती है, तो हम उसे शीघ्र ठीक करते हैं।",
      "महत्वपूर्ण सुधारों को ख़बर में स्पष्ट रूप से चिह्नित किया जाता है और लेख का 'अपडेटेड' समय दिखाया जाता है।",
      `किसी ख़बर में सुधार का सुझाव देने के लिए लेख का लिंक और सही जानकारी के साथ हमें ईमेल करें: ${IMPRINT.email}`,
    ],
  },
  disclaimer: {
    title: "डिस्क्लेमर",
    body: [
      "इस साइट पर प्रकाशित विचार लेखकों के निजी हो सकते हैं; वे ज़रूरी नहीं कि संस्थान के विचार हों।",
      "एजेंसी व अन्य स्रोतों से ली गई ख़बरों के लिए मूल प्रकाशक ज़िम्मेदार हैं। हम सटीकता सुनिश्चित करने का प्रयास करते हैं, परंतु किसी भी त्रुटि के लिए उत्तरदायी नहीं होंगे।",
      "बाहरी लिंक पर क्लिक करने पर आप संबंधित साइट की शर्तों से बंधे होंगे।",
    ],
  },
  grievance: {
    title: "शिकायत अधिकारी",
    body: [
      "सूचना प्रौद्योगिकी (माध्यम दिशानिर्देश और डिजिटल मीडिया आचार संहिता) नियम, 2021 के अनुपालन में नियुक्त शिकायत अधिकारी:",
      `नाम: ${IMPRINT.proprietor}`,
      `ईमेल: ${IMPRINT.email}`,
      `पता: ${IMPRINT.address}`,
      "किसी भी सामग्री से संबंधित शिकायत पर 15 दिनों के भीतर जवाब दिया जाएगा।",
    ],
  },
  refund: {
    title: "रिफंड व रद्द करने की नीति",
    body: [
      "'सपोर्ट करें' के माध्यम से दिया गया सहयोग स्वैच्छिक दान है, किसी सेवा या उत्पाद की खरीद नहीं।",
      "सामान्यतः दान वापस नहीं किया जाता। फिर भी यदि भुगतान गलती से दो बार कट गया हो या तकनीकी त्रुटि हुई हो, तो 7 दिनों के भीतर हमें ईमेल करें — भुगतान की पुष्टि के बाद रिफंड Razorpay के माध्यम से उसी माध्यम पर वापस कर दिया जाएगा।",
      `रिफंड संबंधी संपर्क: ${IMPRINT.email} (Razorpay payment id अवश्य लिखें)`,
    ],
  },
};

export default function InfoPage() {
  const { slug } = useParams();
  const page = PAGES[slug];
  if (!page) {
    return <div className="max-w-3xl mx-auto px-4 py-24 text-center text-muted-foreground">पेज नहीं मिला</div>;
  }
  return (
    <div className="max-w-3xl mx-auto px-4 py-12" data-testid={`info-${slug}`}>
      <Seo title={page.title} description={page.body[0]} path={`/p/${slug}`} />
      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-brk">The Vainor India</span>
      <h1 className="font-hindi text-3xl md:text-4xl mt-2">{page.title}</h1>
      <span className="block gold-rule w-24 mt-3" />
      <div className="mt-6 space-y-4 text-base leading-[1.8] text-inkgray">
        {page.body.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>
      <div className="mt-10 border-t border-subtle pt-6 font-mono text-[11px] text-muted-foreground leading-relaxed">
        {IMPRINT.firm} • GSTIN {IMPRINT.gstin} • {IMPRINT.udyam}
        <br />
        {IMPRINT.address} • {IMPRINT.email} • {IMPRINT.phone}
      </div>
    </div>
  );
}
